/**************************************************
 * Nombre:       Dialogo_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {Check} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Deposito from "../Formularios/Formulario_Deposito";
import {useContext} from "react";
import {usuarioContext} from "../../App";
import {crearDeposito} from "../../CodNegocio/Depositos/crearDeposito";

const Dialogo_Deposito = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: cerrar,
        funcionDos: realizado
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Creando deposito')

        let dox = await crearDeposito({
            usuario: cData.usuario,
            entidad : entidad,
            idBolsillo: datos.idBolsillo,
            nombreBolsillo: datos.nombre
        })

        if (dox.res) {
            terminar({aviso: 'Deposito creado, descarga recibo de pago'})
        } else {
            terminar({aviso: 'Ups algo inesperado paso, intentalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('usuarios', datos.id)
        terminar({aviso: 'Usuarios borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Deposito props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                    startIcon={<Check/>}
                >Crear Deposito</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Deposito